module.exports = __webpack_public_path__ + "static/media/fourth_banner_image.0507c34f.png";